<template>
    <script :id="randomId" type="text/plain" style="width:1024px;height:500px;"></script>
</template>

<script>
    export default {
        name: '',
        props: {
            // 初始化内容
            content: {
                type: String,
                default: ''
            },
            needSync: {
              type: Boolean,
              default: false
            },
            // 所属类型 1 资讯 2 视频 默认0
            contentType: {
              type: Number,
              default: 0
            }
        },
        data() {
            return {
                //每个编辑器生成不同的id,以防止冲突
                randomId: 'editor_' + (Math.random() * 100000000000000000),
                //编辑器实例
                instance: null,
                editorReady: false, // 是否初始化成功
            }
        },
        methods: {
            initEditor() {
                let BASEURL = 'https://www.135editor.com';
                let appkey = '598c1c0e-41e4-421a-8efd-72060a1b09e3';
                let that = this
                // this.$nextTick(() => {
                    this.instance = UE.getEditor(this.randomId, {
                        initialFrameHeight: 420,
                        plat_host: 'www.135editor.com',
                        appkey: appkey,
                        page_url: BASEURL + '/editor_styles/open_styles?inajax=1&appkey=' + appkey,
                        style_url: BASEURL + '/editor_styles/open?inajax=1&v=v2&appkey=' + appkey,
                        style_width: 340,
                        zIndex: 1000,
                        pageLoad: true,
                        open_editor: true,
                        focus: true,
                        focusInEnd: true
                    });
                    // 绑定事件，当 UEditor 初始化完成后，
                    this.instance.addListener('ready', () => {
                      this.editorReady = true

                    });
                    // 返回编辑器内容
                    this.instance.addListener('contentChange', () => {

                      if(this.needSync) {
                        this.$emit('update:content', this.instance.getContent())
                      }else {
                        this.$emit('contentChange', this.instance.getContent())
                      }

                    });
                // });
            }
        },
        components: {

        },
        computed: {

        },
        watch: {
            // 初始化内容
          editorReady(v) {
            if(v) {
              this.instance.setContent(this.content)
            }
          },
            // 初始化内容
          content(v) {
            if(v && this.editorReady && !this.instance.getContent()) {
              this.instance.setContent(this.content)
            }
          }
        },
        mounted() {
            this.initEditor()
        },
        created() {

        },
        beforeDestroy() {
            // 组件销毁的时候，要销毁 UEditor 实例
            if (this.instance !== null && this.instance.destroy) {
                this.instance.destroy();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
